import { Controller, IDynamicLoader, Loader, Toolbar } from '@tencent/workbench';
import { IAnimPaneFeature } from './anim-pane-interface';
import { TOOLBAR_ITEMS, config } from './config';
import { FIXED_KEYS_DOUBLE } from '../../schema/constant';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
})
export class AnimPaneController {
    public constructor(@Loader(IAnimPaneFeature) private loader: IDynamicLoader<IAnimPaneFeature>) {
    }

    // 动画窗格点击回调
    @Toolbar(config.id, 'onClick')
    public onClick() {
        this.feature.onClick();
    }

    // 动画tab点击回调
    @Toolbar(FIXED_KEYS_DOUBLE.TOOLBAR_ANIM, 'onClick')
    public onClickAnimTab() {
        return this.feature.handleAnimTabClick();
    }

    @Toolbar(config.id, 'shouldCheck')
    public shouldCheck() {
        return this.feature.shouldCheck();
    }

    private get feature() {
        return this.loader.instance!;
    }
}
